import { Component, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { EventService } from 'src/app/core/providers/event/event.service';
import { LanguageService } from 'src/app/core/providers/language/language.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/core/providers/auth/auth.service';

import { LAYOUT_MODE } from '../layouts.model';
import { LocalStorageService } from 'src/app/core/providers/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';
import { MessageBusService } from 'src/app/core/providers/busMessage/messageBusService';
import { LoginApiResponse } from 'src/app/core/providers/auth/auth.models';
import { ApiError } from 'src/app/core/providers/error-handling/error.models';
import { AppContextService } from 'src/app/core/providers/context/AppContextService ';
import { filter, Subscription } from 'rxjs';
import { ToastService } from 'src/app/core/providers/toast/toast.service';
import { AddFirmModalComponent } from 'src/app/pages/settings/firm/components/add-firm-modal/add-firm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateProfileModalComponent } from 'src/app/pages/settings/users/components/update-profile-modal/update-profile-modal.component';

@Component({
    selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: false,
})

/**
 * Topbar Component
 */
export class TopbarComponent implements OnInit, OnDestroy {
  mode: string | undefined;
  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  logoUrl: string = '/assets/images/logo-vesper.png';
  apiUrl = environment.apiUrl;
  subscription: Subscription = new Subscription();
  searchQuery: string = '';
  searchTimeout: any;
  currentFolderName: string = '';
  private lastSearchValue: string = '';
  private currentFolderRoute: string = '';



  constructor(
    private router: Router,
    private authService: AuthenticationService<any>,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private eventService: EventService,
    private localStorage: LocalStorageService,
    private messageBus: MessageBusService,
    private authenticationService: AuthenticationService<
      LoginApiResponse | ApiError
    >,
    private appContextService: AppContextService,
    private toastService: ToastService,
    private modalService: NgbModal
  ) {}

  /**
   * Language Listing
   */
  listLang = [
    { text: 'French', flag: 'assets/images/flags/french.jpg', lang: 'fr' },
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
  ];

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  layoutMode!: string;
  context: any;

  ngOnInit(): void {
    this.layoutMode = LAYOUT_MODE;

    this.element = document.documentElement;
    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }

    this.subscription.add(
      this.appContextService.context$.subscribe((context) => {
        this.context = context;
        if (this.context?.message === 'No context for the user') {
          this.logout();
        }
        this.refreshLogo();
      })
    );
    this.subscription.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => this.updateCurrentFolderRoute(event.urlAfterRedirects))
    );
    this.updateCurrentFolderRoute(this.router.url);
    this.onContextChange();
  }

  onSearch(event: Event) {
    event.preventDefault(); // Empêche le rechargement de la page
    if (this.searchQuery.trim()) {
      this.triggerSearch();
    }
  }

  onSearchInput(event: Event) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      const currentSearch = this.searchQuery.trim();
      // Ne déclenche la navigation que si la valeur a changé
      if (currentSearch !== this.lastSearchValue) {
        this.lastSearchValue = currentSearch;
        this.triggerSearch();
      }
    }, 500);
  }

  triggerSearch() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }

    // Navigue avec le paramètre search seulement si searchQuery n'est pas vide
    const queryParams = this.searchQuery.trim() ? { search: this.searchQuery.trim() } : { search: null };

    this.router.navigate(['/my-folders'], {
      queryParams,
    });
  }

  clearSearch() {
    this.searchQuery = '';
    this.triggerSearch(); // Déclenche immédiatement la recherche sans filtre
  }

  onContextChange(): void {
    this.subscription.add(
      this.messageBus.getMessage().subscribe((message) => {
        if (message.type === 'CONTEXT_CHANGED') {
          this.fetchFirmContext();
          return;
        }

        if (message.type === 'COMPANY_FOCUSED' && this.currentFolderRoute) {
          this.currentFolderName = message.content?.name || '';
        }
      })
    );
  }

  private updateCurrentFolderRoute(url: string): void {
    const folderRoute = url.match(/\/my-folders\/view-folder\/([^/?#]+)/)?.[1] || '';

    if (folderRoute !== this.currentFolderRoute) {
      this.currentFolderRoute = folderRoute;
      this.currentFolderName = '';
    }
  }

  switchFirm(firm: any): void {
    if (firm.id == this.context?.currentFirm?.id) return;
    const uri = 'firm-switch/' + firm.id;
    this.subscription.add(
      this.authenticationService.loginBySwitch(uri).subscribe({
        next: (response: LoginApiResponse | ApiError) => {
          if (this.authenticationService.isLoginApiResponse(response)) {
            this.toastService.show({
              message: `Connexion réussie à l'entreprise ${firm.name}. Rafraîchissement puis redirection au niveau du tableau de bord...`,
              classname: 'bg-success text-light',
              delay: 15000,
            });

            setTimeout(() => {
              this.router.navigate(['/']).then(() => {
                window.location.reload();
              });
            }, 2000);
          }
        },
      })
    );
  }

  handleError(error: ApiError): void {
    this.toastService.show({
      message:
        'Une erreur est survenue: ' + (error.message || 'Erreur inconnue'),
      classname: 'bg-danger text-light',
      delay: 15000,
    });
  }

  fetchFirmContext() {
    this.appContextService.loadContext().subscribe({
      next: (response: any) => {},
      error: (error: ApiError) => {},
    });
  }

  refreshLogo() {
    this.logoUrl = this.context?.currentFirm?.logoUrl
      ? `${this.apiUrl}${this.context.currentFirm.logoUrl}`
      : '/assets/images/logo-vesper.png';
  }

  addNewFirmModal() {
    this.modalService.open(AddFirmModalComponent, {
      centered: true,
      size: 'md',
    });
  }

  editProfileModal() {
    this.modalService.open(UpdateProfileModalComponent, {
      centered: true,
      size: 'md',
    });
  }

  get userFullName(): string {
    const user = this.context?.user;
    if (!user) return '';

    const format = (value?: string) =>
      value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';

    const firstName = format(user.firstName);
    const lastName = format(user.lastName);

    return `${firstName} ${lastName}`.trim();
  }

  /**
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Topbar Light-Dark Mode Change
   */
  changeMode(mode: string) {
    this.layoutMode = mode;
    this.mode = mode;
    this.eventService.broadcast('changeMode', mode);
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/account/login']);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
